import { useContext } from "react";
import RightSidebarContext from "contexts/RightSidebarContext";
const useRightSidebar = () => {
  const context = useContext(RightSidebarContext);
  if (!context) {
    throw new Error("useRightSidebar hook needs to be used inside RightSidebarProvider");
  }
  return context;
};
export default useRightSidebar;
